import type { ValidationError } from './types'
import type { Datenherkunft } from '@/types/studyTypes'

export function validateDatenherkunft(d: Datenherkunft): ValidationError[] {
  const errors: ValidationError[] = []

  if (!d.datenQuellen?.length)
    errors.push({ field: 'datenQuellen', message: 'Bitte mindestens eine Datenquelle wählen.' })

  if (d.datenQuellen?.includes('vonExtern') && !d.datenQuelleExtern?.length)
    errors.push({ field: 'datenQuelleExtern', message: 'Bitte externe Datenquelle angeben.' })

  if (d.datenQuelleExtern?.includes('sonstige') && !d.datenQuelleExternSonstiges?.trim())
    errors.push({
      field: 'datenQuelleExternSonstiges',
      message: 'Beschreibung sonstiger externer Quelle ist erforderlich.',
    })

  // showDatenWeitererKliniken is a local ref, but its effect is stored as a non-empty string
  if (
    d.datenWeitererKliniken !== undefined &&
    d.datenWeitererKliniken !== '' &&
    !d.datenWeitererKliniken?.trim()
  )
    errors.push({ field: 'datenWeitererKliniken', message: 'Bitte Kliniken angeben.' })

  // showExterneDaten effect stored as non-empty string
  if (
    d.verwendungszweckVerknuepfungExtern !== undefined &&
    d.verwendungszweckVerknuepfungExtern !== '' &&
    !d.verwendungszweckVerknuepfungExtern?.trim()
  )
    errors.push({
      field: 'verwendungszweckVerknuepfungExtern',
      message: 'Verwendungszweck ist erforderlich.',
    })

  return errors
}
